import ozAccordionDevelopmentTypes from './oz-accordion-development-types.vue'

export default ozAccordionDevelopmentTypes
